import { render, staticRenderFns } from "./VechileColorTable.vue?vue&type=template&id=3e359cb2&"
import script from "./VechileColorTable.vue?vue&type=script&lang=js&"
export * from "./VechileColorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports